import React, { useCallback, useRef, useState } from "react";
import { Button } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import { EmojiData, Picker } from 'emoji-mart'
import { useMouseLeave } from '../../..';
import 'emoji-mart/css/emoji-mart.css';

type Props = {
    disabled: boolean;
    iconClassname?: string;
    onSelect: (emoji: string) => void;
}
const EmojiInput: React.FC<Props> = ({ disabled, iconClassname, onSelect }) => {

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerTouched, setPickerTouched] = useState(false);

    const emojiWrapper = useRef(null);
    useMouseLeave(emojiWrapper.current, () => {
        setPickerVisible(false);
    });

    const addEmoji = useCallback((emoji: EmojiData) => {
        if ("native" in emoji) {
            onSelect(emoji.native);
        }
    }, []);

    return <div ref={emojiWrapper} className='relative'>
        <div className='absolute' style={{ right: 0, bottom: 25, display: pickerVisible ? 'block' : 'none' }}>
            {pickerTouched &&
                <Picker native
                    onSelect={(data) => addEmoji(data)}
                    sheetSize={16}
                    emojiSize={16}
                    showSkinTones={false}
                    showPreview={false} />}
        </div>
        <Button type='link'
            size='large'
            className="emoji-picker-btn"
            disabled={disabled}
            onMouseEnter={() => {

                setPickerVisible(true);
                setPickerTouched(true);
            }}
            icon={<SmileOutlined className={iconClassname} />} />
    </div>;
}

export default EmojiInput;